import { GenerationAnimation } from "@ui/components/routes/music/GenerationAnimation";

import { Block } from "./Block";

export const BlockMusicIntroduction = () => {
  return (
    <Block name='music-introduction' className='bg-white'>
      <GenerationAnimation embeddedInBlock />
    </Block>
  );
};
